var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgViewBoards(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 21C3.44772 21 3 20.5523 3 20L3 14C3 13.4477 3.44772 13 4 13L10 13C10.5523 13 11 13.4477 11 14L11 20C11 20.5523 10.5523 21 10 21L4 21ZM4 11C3.44772 11 3 10.5523 3 10L3 4C3 3.44772 3.44772 3 4 3L10 3C10.5523 3 11 3.44772 11 4L11 10C11 10.5523 10.5523 11 10 11L4 11ZM14 21C13.4477 21 13 20.5523 13 20L13 14C13 13.4477 13.4477 13 14 13L20 13C20.5523 13 21 13.4477 21 14L21 20C21 20.5523 20.5523 21 20 21L14 21Z",
    fill: "#3D1CAF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 4L13 10C13 10.5523 13.4477 11 14 11L20 11C20.5523 11 21 10.5523 21 10L21 4C21 3.44772 20.5523 3 20 3L14 3C13.4477 3 13 3.44772 13 4Z",
    fill: "#3D1CAF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewBoards);
export default __webpack_public_path__ + "static/media/ViewBoards.fb14fecf124e1dbeeb7c56676faa1b0a.svg";
export { ForwardRef as ReactComponent };